import { render, staticRenderFns } from "./MemberAlertsDisplay.vue?vue&type=template&id=47e55c1e&scoped=true"
import script from "./MemberAlertsDisplay.vue?vue&type=script&lang=js"
export * from "./MemberAlertsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e55c1e",
  null
  
)

export default component.exports